export const i18n = {
  defaultLocale: 'en',
  locales: ['sv', 'en', 'da', 'no'],
} as const;

export type Locale = (typeof i18n)['locales'][number];

export const defaultLocale = i18n.defaultLocale;
export const locales = i18n.locales;

export const localeNames: Record<Locale, string> = {
  sv: 'Svenska',
  en: 'English',
  da: 'Dansk',
  no: 'Norsk',
};

export const localeFlags: Record<Locale, string> = {
  sv: 'SV',
  en: 'EN',
  da: 'DA',
  no: 'NO',
};

export function isValidLocale(locale: string): locale is Locale {
  return i18n.locales.includes(locale as Locale);
}
